import { Flex } from '@chakra-ui/layout';
import { t } from '@lingui/macro';
import React from 'react';

import { Button } from '../../../../components/three-essentials/button/button';
import {
    BadgeContainer,
    Title,
    IconContainer,
    IconSvg,
    Description
}from './three-essentials-badge.styled';
import {
    TeacherAdminIcon,
    TeacherAdminIcons
} from '@components';

type ThreeEssentialsBadgeProps = {
title?: string
description?: string
icon: TeacherAdminIcons
showButton?: boolean
clickHandler: () => void
};

export const ThreeEssentialsBadge = ({
    title, icon, description, showButton, clickHandler
}: ThreeEssentialsBadgeProps) => {
    return (
        <BadgeContainer onClick={clickHandler}>
            <IconContainer>
                {icon && (
                    <IconSvg>
                        <TeacherAdminIcon
                            icon={icon}
                            width={25}
                        />
                    </IconSvg>
                )}
            </IconContainer>
            <Flex direction={'column'}>
                <Title>{title}</Title>
                <Description>{description}</Description>
                { showButton && <Button title={t`threeEssentials.manage`} />}
            </Flex>
        </BadgeContainer>
    );
};
